"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const FlatListItem_1 = __importDefault(require("../FlatListItem"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const valueIsControlsStyleComplexUnitPercentage_1 = __importDefault(require("../../../typeAssertions/valueIsControlsStyleComplexUnitPercentage"));
const useControlEvents_1 = __importDefault(require("../../hooks/useControlEvents"));
const isMatched_1 = __importDefault(require("../../../shared/isMatched"));
const style_1 = __importDefault(require("./style"));
const useFlatListItemWrapperStyle_1 = __importDefault(require("../../hooks/useFlatListItemWrapperStyle"));
const useContainerStyle_1 = __importDefault(require("../../hooks/useContainerStyle"));
const valueIsRecord_1 = __importDefault(require("../../../typeAssertions/valueIsRecord"));
const FlatListRenderer = ({ control, parent, style, }) => {
    const [segmentsOnList, setSegmentsOnList] = (0, react_1.useState)(1);
    const [searchInput, setSearchInput] = (0, react_1.useState)('');
    const { Render, dimentions, functions: { processor }, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const events = (0, useControlEvents_1.default)(control);
    const numColumns = (0, react_1.useMemo)(() => {
        if (control.numColumns && control.numColumns && Number.isInteger(control.numColumns)) {
            const newValue = Number(control.numColumns);
            if (newValue > 1) {
                return newValue;
            }
        }
        return undefined;
    }, [control.numColumns]);
    const isDimentionPorcent = (0, react_1.useMemo)(() => {
        var _a;
        if (control.isHorizontal && control.controls) {
            const [firstControl] = control.controls;
            if ((0, valueIsControlsStyleComplexUnitPercentage_1.default)((_a = firstControl === null || firstControl === void 0 ? void 0 : firstControl.style) === null || _a === void 0 ? void 0 : _a.width)) {
                return true;
            }
        }
        return false;
    }, [
        control.controls,
        control.isHorizontal,
    ]);
    const { filterProperty } = control;
    const listData = (0, react_1.useMemo)(() => {
        if (control.controls) {
            if (control.filterEnabled && filterProperty && searchInput) {
                return control.controls
                    .map((childControl) => ({ control: childControl, key: childControl.id }))
                    .filter((listItem) => {
                    var _a;
                    const controlContext = listItem.control && (processor === null || processor === void 0 ? void 0 : processor.root.getControlRunContext(listItem.control.id));
                    const itemContextData = (_a = controlContext === null || controlContext === void 0 ? void 0 : controlContext.itemContext) === null || _a === void 0 ? void 0 : _a.data;
                    const propValue = (0, valueIsRecord_1.default)(itemContextData) ? itemContextData[filterProperty] : '';
                    return (0, isMatched_1.default)(`${searchInput}`, `${propValue}`);
                });
            }
            return control.controls
                .map((childControl) => ({ control: childControl, key: childControl.id }));
        }
        return [];
    }, [control.controls, control.filterEnabled, filterProperty, searchInput, processor]);
    const itemHeigth = (0, react_1.useMemo)(() => {
        if (!control.controls || !control.controls[0]) {
            return undefined;
        }
        const referenceControl = control.controls[0];
        if (!referenceControl.style || !referenceControl.style.height) {
            return undefined;
        }
        return referenceControl.style.height.value;
    }, [control.controls]);
    const itemsOnSegment = (0, react_1.useMemo)(() => {
        if (!itemHeigth) {
            return undefined;
        }
        const screenHeight = dimentions.window.height;
        return Math.floor((screenHeight / itemHeigth) * 1.2);
    }, [itemHeigth, dimentions.window.height]);
    const segmentedData = (0, react_1.useMemo)(() => {
        if (!itemsOnSegment) {
            return [];
        }
        const maximunIndex = segmentsOnList * itemsOnSegment;
        return listData.filter((_, index) => index <= maximunIndex);
    }, [itemsOnSegment, listData, segmentsOnList]);
    const flatListItemContainer = (0, useFlatListItemWrapperStyle_1.default)(control, numColumns);
    const renderItem = (0, react_1.useCallback)(({ item: { control: itemControl } }) => (react_1.default.createElement(FlatListItem_1.default, { control: itemControl, flatListItemContainer: flatListItemContainer, View: Render.View })), [flatListItemContainer, Render]);
    const customBaseStyle = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, style), { flexDirection: 'column' })), [style]);
    const containerStyle = (0, useContainerStyle_1.default)(customBaseStyle, parent);
    const containerMessageStyle = (0, react_1.useMemo)(() => ({
        backgroundColor: 'white',
    }), []);
    const handleOnEndReached = (0, react_1.useCallback)((...eventParams) => {
        if (segmentedData.length < listData.length) {
            setSegmentsOnList((previus) => previus + 1);
        }
        else if (events.onReachEnd) {
            events.onReachEnd(eventParams);
        }
    }, [events, listData.length, segmentedData.length]);
    return (react_1.default.createElement(Render.View, { style: containerStyle }, !isDimentionPorcent ? (react_1.default.createElement(react_1.default.Fragment, null,
        control.filterEnabled && (react_1.default.createElement(Render.TextInput, { isFocused: false, placeholder: control.filterPlaceholder || `Search by ${control.filterProperty}`, placeholderTextColor: "#bdbdbd", value: searchInput, onChangeText: setSearchInput, style: style_1.default })),
        react_1.default.createElement(Render.FlatList, { refreshing: false, horizontal: !!control.isHorizontal, data: segmentedData, renderItem: renderItem, inverted: control.inverted || false, numColumns: numColumns, onRefresh: events.onRefresh, onEndReachedThreshold: 1, onEndReached: handleOnEndReached, onScroll: events === null || events === void 0 ? void 0 : events.onScroll, onScrollEndDrag: events.onScrollEndDrag, onScrollBeginDrag: events.onScrollBeginDrag }))) : (react_1.default.createElement(Render.View, { style: containerMessageStyle },
        react_1.default.createElement(Render.Text, null, "Horizontal list do not allow dimensions in percentages")))));
};
exports.default = FlatListRenderer;
